import { useInstantSearch } from 'react-instantsearch';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { Vertical } from '@sorare/core/src/atoms/layout/flex';
import { LabelM } from '@sorare/core/src/atoms/typography';
import { FilterTitle } from '@sorare/core/src/components/search/FilterTitle';
import { FILTERS, FilterWidget } from '@sorare/core/src/lib/filters';
import { filters } from '@sorare/core/src/lib/glossary';

import { makeRangeFilter } from 'searchCards/RangeSlider';

import RangeSlider from '../../search/RangeSlider';

const AverageScoreTitle = () => {
  const { indexUiState } = useInstantSearch();

  const selected =
    (indexUiState.range?.[FILTERS.lastFiveAverageScore.attribute] ? 1 : 0) +
    (indexUiState.range?.[FILTERS.lastFifteenAverageScore.attribute] ? 1 : 0);

  return <FilterTitle name={filters.averageScore} selected={selected} />;
};

const Root = styled(Vertical).attrs({ gap: 3 })``;
const Section = styled(Vertical)`
  &:not(:has(.FilterWidget.visible)) {
    display: none;
  }
`;

const AverageScoreComponent = ({
  fiveAverageScoreWidget,
  fifteenAverageScoreWidget,
  visible,
}: {
  fiveAverageScoreWidget: FilterWidget;
  fifteenAverageScoreWidget: FilterWidget;
  visible: boolean;
}) => {
  return (
    <Root>
      <Section>
        <LabelM color="var(--c-nd-600)">
          <FormattedMessage {...FILTERS.lastFiveAverageScore.title} />
        </LabelM>
        {fiveAverageScoreWidget.Component({ visible })}
      </Section>
      <Section>
        <LabelM color="var(--c-nd-600)">
          <FormattedMessage {...FILTERS.lastFifteenAverageScore.title} />
        </LabelM>
        {fifteenAverageScoreWidget.Component({ visible })}
      </Section>
    </Root>
  );
};

export const RefineAverageScore = (): FilterWidget => {
  const fiveAverageScoreWidget = makeRangeFilter(
    ({ visible }) => (
      <RangeSlider
        attribute={FILTERS.lastFiveAverageScore.attribute}
        visible={visible}
      />
    ),
    FILTERS.lastFiveAverageScore
  );

  const fifteenAverageScoreWidget = makeRangeFilter(
    ({ visible }) => (
      <RangeSlider
        attribute={FILTERS.lastFifteenAverageScore.attribute}
        visible={visible}
      />
    ),
    FILTERS.lastFifteenAverageScore
  );

  return {
    key: FILTERS.averageScore.attribute,
    type: 'range',
    attribute: FILTERS.averageScore.attribute,
    title: <AverageScoreTitle />,
    Component: ({ visible }) => (
      <AverageScoreComponent
        fiveAverageScoreWidget={fiveAverageScoreWidget}
        fifteenAverageScoreWidget={fifteenAverageScoreWidget}
        visible={visible}
      />
    ),
  };
};
